import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
var CLASSNAME = 'Icons-profile';
var ID = 'icon-profile';
/* eslint-disable max-len */

var SVGProfile = function SVGProfile() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 15 13"
  }, React.createElement("path", {
    d: "M8.98066951,7.44670141 C9.45343257,6.94114553 9.81142079,6.14865254 10.1803399,5.21132462 C10.3934932,4.6702432 10.3552349,4.20567834 10.3552349,3.54708933 C10.3552349,3.0606626 10.4481479,2.27910054 10.3279076,1.85006123 C9.91799743,0.398979232 8.89048927,0 7.68262064,0 C6.47475201,0 5.44451112,0.401711966 5.03733368,1.8555267 C4.91709336,2.28183328 5.01000634,3.06339533 5.01000634,3.54708933 C5.01000634,4.20841107 4.97448079,4.67297593 5.18763408,5.21679009 C5.55928596,6.15685074   5.91180871,6.946611 6.38183904,7.45216688 C4.54817421,7.78829322 3.3102455,8.74475028 2.47676149,9.11640217 C0.746940574,9.88703328 0.738742371,10.7314482 0.738742371,10.7314482 L0.738742371,12.1661338 L14.6620245,12.1634011 L14.6620245,10.7314482 C14.6620245,10.7314482 14.6538263,9.88430055 12.9185399,9.11366943 C12.0768577,8.73928481 10.827998,7.77736228 8.98066951,7.44670141 Z"
  }));
};
/* eslint-disable max-len */


var Profile = function Profile(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGProfile
  });
};

Profile.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Profile;